import { SchemaField } from '@okletsplay/core';
import React, { FC, useMemo } from 'react';
import { SelectInput } from 'shared/components/Form/SelectInput';
import { TextInput } from 'shared/components/Form/TextInput';

interface DynamicSchemaFieldProps {
  field: SchemaField;
  value: unknown;
  onChange: (value: unknown) => void;
  isEditable?: boolean;
}

export const DynamicSchemaField: FC<DynamicSchemaFieldProps> = ({
  field,
  value,
  onChange = () => null,
  isEditable = false,
}) => {
  const options = useMemo(
    () =>
      field?.enum?.map((item: string | number) => ({
        label: field.visibilityConfig.enumFormat?.[item] ?? item.toString(),
        value: item,
      })) ?? [],
    [field?.enum, field.visibilityConfig.enumFormat]
  );

  if (Array.isArray(field.enum)) {
    return (
      <SelectInput onChange={onChange} options={options} value={value} disabled={!isEditable} />
    );
  } else {
    return <TextInput onChange={onChange} value={value as string} disabled={!isEditable} />;
  }
};
